/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum WorkspaceType {
    Building = 'BUILDING',
    Office = 'OFFICE'
}

export function WorkspaceTypeFromJSON(json: any): WorkspaceType {
    return WorkspaceTypeFromJSONTyped(json, false);
}

export function WorkspaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceType {
    return json as WorkspaceType;
}

export function WorkspaceTypeToJSON(value?: WorkspaceType | null): any {
    return value as any;
}

